import './GalleryDisplay.css';
import GalleryImg from "./GalleryImg";

const photos = [
    {
        link: "gallery/labo.webp",
        alt: "gallery/labo.webp"
    },
    {
        link: "gallery/1.webp",
        alt: "1.webp"
    },
    {
        link: "gallery/2.webp",
        alt: "gallery/2.webp"
    },
    {
        link: "gallery/materiel.webp",
        alt: "materiel.webp"
    },
    {
        link: "gallery/raspberry.webp",
        alt: "gallery/raspberry.webp"
    },
    {
        link: "gallery/9.webp",
        alt: "gallery/9.webp"
    },
    {
        link: "gallery/3.webp",
        alt: "gallery/3.webp"
    },
    {
        link: "gallery/coupure.webp",
        alt: "gallery/coupure.webp"
    },
    {
        link: "gallery/5.webp",
        alt: "gallery/5.webp"
    },
    {
        link: "gallery/11.webp",
        alt: "gallery/11.webp"
    },
]

const GalleryDisplay = () =>{
    return (
        <div className={"container gallery"} id={"gallery"}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <h2 className={"title"}>Quelques images </h2>
                    <p className={"subtitle"}>sur ce que nous faisons</p>
                </div>
            </div>
            <div className={"row"}>
                {
                    photos.map(photo => (
                        <GalleryImg link={photo.link} alt={photo.alt}></GalleryImg>
                    ))
                }
            </div>
        </div>
    );
}

export default GalleryDisplay;